import request from '../utils/request';

export const createInvitationAPI = async (eventId: string, userId: string) => {
    await request.post(`/invitations/${eventId}`, {
        userId,
    });
};
